<div class="tc">
  <!-- Search and the one action -->
  <div class="set-toolbar">
    <app-search-input label="Search test numbers"
      class="set-toolbar__search"
      placeholder="Search by first name or number"
      (valueChange)="updateSearchTerm($event)"
    />

    @if (canCreateTestUser) {
      <div class="set-toolbar__end">
        <button type="button" class="bk-btn bk-btn--primary" (click)="showAddUser = true">
          <span class="bk-sym" aria-hidden="true">add</span>
          Add test number
        </button>
      </div>
    }
  </div>

  <p class="set-summary tc__summary" aria-live="polite">
    @if (loading && !testContacts.length) {
      <span class="bk-skel tc__summary-skel" aria-hidden="true"></span>
    } @else if (!loadFailed) {
      <span>{{ summary }}</span>
      <span>Each test is a real SMS to that phone.</span>
    }
  </p>

  <app-test-contacts-table
    [testContacts]="testContacts"
    [loading]="loading"
    [params]="reactiveParams"
    [page]="page"
    [pageSize]="pageSize"
    [totalItems]="testContactsCount"
    [totalPages]="totalPages"
    [searchTerm]="searchTerm"
    [loadFailed]="loadFailed"
    [canManage]="canCreateTestUser"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (addTestContact)="showAddUser = true"
    (retry)="reload()"
    (fetchTestContacts)="reload()"
  ></app-test-contacts-table>

  <!-- add test number modal -->
  @if (showAddUser) {
    <app-add-test-user-form
      [openModal]="showAddUser"
      (onClose)="showAddUser = false"
      (fetchTestContacts)="reload()"
      (onSuccess)="onAddSuccess()"
    ></app-add-test-user-form>
  }
</div>
